import { getFullname } from '@/misc/PersonHelper'

export const getters = {
  fullName: (state) => state.currentStay ? getFullname(state.currentStay.patient.lastName, state.currentStay.patient.maidenName, state.currentStay.patient.firstName) : null
}